export default {
  buttons: {
    start: 'Empezar a preparar el pedido programado',
  },
};
